import get from 'lodash/get';
import isNil from 'lodash/isNil';

/* eslint-disable no-param-reassign, import/prefer-default-export */
export function getKpiDistribution(granularKPIs, kpi) {
  return granularKPIs.reduce(
    (shares, { aggregationLevel, productCode, countryCode, ...kpis }) => {
      const currentKPI = get(kpis, kpi);

      if (isNil(currentKPI)) return shares;

      shares[productCode] = shares[productCode] || {};

      shares[productCode][countryCode] = {
        value: kpis[kpi],
        aggregationLevel,
      };

      return shares;
    },
    {},
  );
}
/* eslint-enable no-param-reassign, import/prefer-default-export */
